import React, { StatelessComponent } from 'react';
import b from 'b_';

import Rect from '@components/rect';

import './publication-item.stub.css';

interface PublicationsStubProps {
    itemsCount: number;
    type: 'vertical' | 'horizontal';
}

const class_ = b.with('publication-item-stub');

const PublicationsStub: StatelessComponent<PublicationsStubProps> = ({ itemsCount, type }) => {
    const items = Array(itemsCount).fill(0);

    return (
        <div className={class_({ type })}>
            {items.map((_: any, index: number) => (
                <div key={index} className={class_('item')}>
                    <Rect className={class_('image')} />
                    <div className={class_('description')}>
                        <Rect height={34} />
                        <Rect height={34} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PublicationsStub;
